<template>
    <div>
        <el-alert show-icon :closable="false">
            <p>如果只需要使用OBS直接进行直播，则只需要完善【推流相关设置】</p>
            <p>如果需要使用OBS从其他媒体源进行直播转播，则需要完善【推流相关设置】+【拉流相关设置】</p>
        </el-alert>
        <div>
            <el-card header="推流相关设置" class="MT10">
                <dl>
                    <dt>相关说明:</dt>
                    <dd>1、推流地址是固定的，无法修改</dd>
                    <dd>2、点击按钮【获取推流密钥】，为当前用户生成专享的密钥，<span class="color-danger">密钥请勿泄露</span></dd>
                    <dd>3、将推流地址以及推流密钥分别填写到OBS的服务器相关配置项中</dd>
                </dl>
                <dl class="MT10">
                    <dt>推流地址:</dt>
                    <dd v-if="pageData">
                        {{pageData.pushStreamUrl}}
                        <el-button type="text" icon="el-icon-copy-document" size="mini" @click="copy(pageData.pushStreamUrl)">点击复制</el-button>
                    </dd>
                </dl>
                <dl class="MT10">
                    <dt>推流密钥: <el-button type="text" size="mini" icon="el-icon-key" :loading="loading1" @click="getStreamKey">获取推流密钥</el-button></dt>
                    <dd>
                        <div class="color-danger">每次获取新的密钥后，旧的密钥将会失效</div>
                    </dd>
                    <dd v-if="streamKey">
                        {{streamKey}}
                        <el-button type="text" icon="el-icon-copy-document" size="mini" @click="copy(streamKey)">点击复制</el-button>
                    </dd>
                </dl>
            </el-card>
            <el-card header="拉流相关设置" class="MT10">
                <dl>
                    <dt>相关说明:</dt>
                    <dd>1、点击按钮【获取拉流地址及密钥】，为当前用户生成专享的拉流地址信息，<span class="color-danger">地址信息请勿泄露</span></dd>
                    <dd>2、将整个拉流地址以及密钥填写到OBS的媒体源相关配置项中</dd>
                </dl>
                <dl class="MT10">
                    <dt>拉流地址及密钥: <el-button type="text" size="mini" icon="el-icon-key" :loading="loading2" @click="getPageData">获取拉流地址及密钥</el-button></dt>
                    <dd>
                        <div class="color-danger">每次获取新的地址信息后，旧的地址信息将会失效</div>
                    </dd>
                    <template v-if="pageData && pageData.playStreamUrl">
                        <dd>
                            {{pageData.playStreamUrl}}
                            <el-button type="text" icon="el-icon-copy-document" size="mini" @click="copy(pageData.playStreamUrl)">点击复制</el-button>
                        </dd>
                        <dd>
                            <div class="color-danger">最新获取时间：{{$utils.formatDate(nowTime,'yyyy-MM-dd HH:mm')}}，请在10分钟以内使用，否则将过期，过期以后需要重新获取</div>
                        </dd>
                    </template>
                </dl>
            </el-card>
            <el-card class="MT10">
                <div slot="header">直播管理员 <small class="color-info">只有直播管理员才可以进入直播控制台</small></div>
                <div>
                    <el-input v-model="userIds" type="textarea" placeholder="管理员ID" :rows="2"></el-input>
                    <div class="MT10"><small class="color-info">填写乐迷或者B类用户账号ID，多个ID之间用英文逗号分隔</small></div>
                </div>
                <div class="btns MT20">
                    <el-button type="primary" @click="updateAdminUserId" :loading="btnLoading">保 存</el-button>
                    <el-button @click="openLiveControl">进入直播控制台</el-button>
                </div>
            </el-card>
        </div>

        <input class="copyTool" ref="copyTool" :value="copyValue" />
    </div>
</template>

<script>
export default {
    props:{
        userId:{
            type:[Number,String],
            default:''
        },
        userType:{
            type:[Number,String],
            default:''
        },
        userName:{
            type:String,
            default:''
        }
    },
    data(){
        return{
            loading1:false,
            loading2:false,
            btnLoading:false,
            action:{
                2:{ // 艺人
                    getStreamkey:'/performer/getStreamkey',
                    getliveRoom:'/performer/getliveRoom',
                    updateAdminUserId:'/performer/updateAdminUserId',
                },
                3:{ // 场地
                    getStreamkey:'/site/getStreamkey',
                    getliveRoom:'/site/getliveRoom',
                    updateAdminUserId:'/site/updateAdminUserId',
                },
                5:{ // 厂牌
                    getStreamkey:'/brand/getStreamkey',
                    getliveRoom:'/brand/getliveRoom',
                    updateAdminUserId:'/brand/updateAdminUserId',
                }
            },
            streamKey:'',
            pageData:null,
            copyValue:'',
            copyTimer:null,
            nowTime: new Date().getTime(),
            userIds:'',
            ssLiveControl: process.env.VUE_APP_LIVECONTROL_URL
        }
    },
    mounted(){
        // this.getTlData();
        this.getPageData();
    },
    methods:{
        //获取推流信息
        getStreamKey(){
            this.loading1 = true;
            this.$request({
                url: this.action[this.userType].getStreamkey,
                method: "POST",
                data: {id: this.userId},
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg, result } = res.data;
                    if (state && state == 1) {
                        this.streamKey = result || '';
                    } else {
                        return this.$message.error(msg || "获取推流信息失败");
                    }
                }).catch(() => {
                    return this.$message.error("获取推流信息失败");
                })
                .finally(() => {
                    this.loading1 = false;
                });
        },
        //获取拉流及页面信息
        getPageData(){
            this.loading2 = true;
            this.$request({
                url: this.action[this.userType].getliveRoom,
                method: "POST",
                params: {id: this.userId},
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg, result } = res.data;
                    if (state && state == 1) {
                        this.nowTime = new Date().getTime();
                        this.pageData = result;
                        this.streamKey = result.liveRoom.streamKey || '';
                        this.userIds = result.liveRoom.adminUserId;

                        this.$emit('update:userName',result.userInfo.name)
                    } else {
                        return this.$message.error(msg || "获取直播信息失败");
                    }
                }).catch(() => {
                    return this.$message.error("获取直播信息失败");
                })
                .finally(() => {
                    this.loading2 = false;
                });
        },
        //复制链接
        copy(str){
            this.copyValue = str;
            clearTimeout(this.copyTimer);
            this.copyTimer = setTimeout(() => {
                const e = this.$refs.copyTool;
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            },300)
        },
        //编辑管理员
        updateAdminUserId(){
            this.btnLoading = true;
            this.$request({
                url: this.action[this.userType].updateAdminUserId,
                method: "POST",
                params: {id: this.userId,userIds:this.userIds},
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$message.success('操作成功');
                    } else {
                        return this.$message.error(msg || "操作失败");
                    }
                }).catch(() => {
                    return this.$message.error("操作成功");
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        },
        //打开直播主控台
        openLiveControl(){
            window.open(this.ssLiveControl+'/live/room/'+this.userId);
        }
    }
}
</script>

<style lang="scss" scoped>
.el-card{
    dl{
        dt{
            // font-size: 14px;
            margin-bottom: 5px;
        }
        dd{
            line-height: 1.8;
            color: $--color-info;
            word-break: break-all;
        }
    }
}
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
}
</style>